import React, { useState ,Fragment} from "react";
import { Row, Col } from "reactstrap";
import { Dropdown, DropdownMenu,DropdownItem, DropdownToggle } from 'reactstrap';
const ActionOptions = ({ children }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  return (
    <Fragment>
    {/* <div className="table-actions">
      <Col xs="12" className="row-actions">
        <i
          className="fa fa-ellipsis-h"
          onClick={() => setToggleMenu(!toggleMenu)}
        ></i>
        <ul
          className="action-options"
          style={toggleMenu ? { display: "" } : { display: "none" }}
          onBlur={() => {
            setToggleMenu(false);
          }}
        >
          {children}
        </ul>
      </Col>
    </div> */}
    <Dropdown className="table-actions" isOpen={dropdownOpen} toggle={toggle} direction={'start'}>
      <DropdownToggle tag={'i'} className="fa fa-ellipsis-h">
      </DropdownToggle>
      <DropdownMenu container="body"
       style={{background: "linear-gradient(175.98deg, #FFFFF0 13.86%, #39B54A 150%)"}}
        className="action-options" >
      {children}
      </DropdownMenu>
    </Dropdown>
    </Fragment>
  );
};

export default ActionOptions;
